import React, {useContext, useEffect} from "react"
import {useHistory, useLocation} from "react-router-dom"

import {URL_FRONT, URL_BACKOFFICE_TRANSCODE_IMPORT_LIST, URL_BACKOFFICE_MEDIA_COLLECTION_ADD, URL_BACKOFFICE_MEDIA_MOVIE_ADD, URL_BACKOFFICE_MEDIA_SHOW_ADD, URL_BACKOFFICE_TRANSCODE_IMPORT_ADD_LIST, URL_BACKOFFICE_STORAGE_PROVIDER_ADD, URL_BACKOFFICE_STORAGE_PROVIDER_LIST, URL_BACKOFFICE_STORAGE_PROVIDER_SCAN, URL_BACKOFFICE_STORAGE_INGESTION_INBOX, URL_FRONT_SEARCH, URL_BACKOFFICE_USER_ADD, URL_BACKOFFICE_USER_LIST} from "static/constant/url"


import "./style.scss"
import {userContext} from "context/User"
import {menuIsOpenContext} from "context/Navigation/menuIsOpen"
import {useQuery} from "@apollo/client"
import importCount from "graphql/Transcode/Import/query/importCount"

export const Menu = (props: any) => {

  const {data} = useQuery(importCount)

  const history = useHistory()
  const location = useLocation()
  const user = useContext(userContext)
  const {state, update} = useContext(menuIsOpenContext)

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") update(false)
    }

    document.body.classList.toggle("menu-open", state)
    window.addEventListener("keydown", onKeyDown)

    return () => {
      document.body.classList.remove("menu-open")
      window.removeEventListener("keydown", onKeyDown)
    }
  }, [state, update])

  const onLinkClick = (URL: string) => {
    props?.closeMenu()
    history?.push(URL)
  }
  const {isAdmin} = user || {}

  const nbImport = data?.importCount?.length

  const MenuLink = ({label, url, badge}: {label: string, url: string, badge?: number}) => <li>
    <button
      className="menu-link"
      type="button"
      aria-current={location.pathname === url ? "page" : undefined}
      onClick={() => onLinkClick(url)}
    >
      <span>{label}</span>
      {!!badge && <span className="badge badge-light">{badge}</span>}
    </button>
  </li>

  return <div className={state ? "menu-container is-open" : "menu-container"}>
    <button
      className="menu-button"
      type="button"
      aria-label={state ? "Fermer le menu" : "Ouvrir le menu"}
      aria-expanded={state}
      aria-controls="main-navigation"
      onClick={() => update(!state)}
    >
      <span className={state ? "icon-close" : "icon-bars"} aria-hidden="true" />
    </button>
    <button className="menu-backdrop" type="button" aria-label="Fermer le menu" onClick={() => update(false)} />
    <nav id="main-navigation" className={state ? "banner visible" : "banner"} aria-hidden={!state}>
        <div className="content">
          <ul>
            <MenuLink label="Accueil" url={URL_FRONT} />
            <MenuLink label="Rechercher" url={URL_FRONT_SEARCH} />
          </ul>
          {isAdmin && <div className="admin-navigation">
            <h1>Backoffice</h1>
            <section>
              <h2>Import</h2>
              <ul>
                <MenuLink label="Ajouter des imports" url={URL_BACKOFFICE_TRANSCODE_IMPORT_ADD_LIST} />
                <MenuLink label="Lister les imports" url={URL_BACKOFFICE_TRANSCODE_IMPORT_LIST} badge={nbImport} />
              </ul>
            </section>
            <section>
              <h2>Media</h2>
              <ul>
                <MenuLink label="Ajouter une série" url={URL_BACKOFFICE_MEDIA_SHOW_ADD} />
                <MenuLink label="Ajouter un film" url={URL_BACKOFFICE_MEDIA_MOVIE_ADD} />
                <MenuLink label="Ajouter une collection" url={URL_BACKOFFICE_MEDIA_COLLECTION_ADD} />
              </ul>
            </section>
            <section>
              <h2>Stockage</h2>
              <ul>
                <MenuLink label="Inbox média" url={URL_BACKOFFICE_STORAGE_INGESTION_INBOX} />
                <MenuLink label="Ajouter un provider" url={URL_BACKOFFICE_STORAGE_PROVIDER_ADD} />
                <MenuLink label="Lister les providers" url={URL_BACKOFFICE_STORAGE_PROVIDER_LIST} />
                <MenuLink label="Scanner les providers" url={URL_BACKOFFICE_STORAGE_PROVIDER_SCAN} />
              </ul>
            </section>
            <section>
              <h2>Utilisateurs</h2>
              <ul>
                <MenuLink label="Ajouter un utilisateur" url={URL_BACKOFFICE_USER_ADD} />
                <MenuLink label="Lister les utilisateurs" url={URL_BACKOFFICE_USER_LIST} />
              </ul>
            </section>
          </div>}
          {user?.email && <div className="footer-container">
            <div className="footer">
              {user.email}
            </div>
          </div>}
        </div>
      </nav>
  </div>
}
